module.exports = __webpack_public_path__ + "media/images/emblems/Alberswil_LU-8189966c7cef65c9bfcb28031af34b98.png";